
export default {
    zh: {
        title: '品评报告(制成)',
    },
    en: {
        title: 'Sensory Report',
    }
}
